import React from 'react'
import InlineSvg from '../image/InlineSvg'

type Props = {
  outlined?: boolean,
  border?: boolean,
  transparent?: boolean,
  children: string | React.ReactElement,
  iconSrc?: string,
  solid?: boolean
  iconClass?: string
  variant?: 'electric-green' | 'dark-green' | 'deep-green'
}
const Tag: React.FC<Props> = ({ transparent, outlined, border, children, iconSrc, solid, iconClass, variant = 'soft-green' }) => {
  let classes = 'text-2xs sm:text-xs rounded-md inline-flex items-center gap-x-2 bg-deep-green whitespace-nowrap'
  let bg = 'bg-white py-1 px-3'
  if(!border && outlined) {
    classes = `${classes} text-deep-green`
  }
  if(outlined && border) {
    classes = `px-3 border border-solid border-deep-green ${classes} text-black`
  }
  if(transparent) {
    bg = 'bg-transparent py-1 text-black'
  }

  if(solid) {
    classes = 'text-2xs sm:text-xs'
    const bgColor = variant === 'electric-green' ? 'bg-electric-green' : variant === 'deep-green' ? 'bg-deep-green text-electric-green'  : 'bg-soft-green my-1'
    bg = `inline-flex gap-x-2 items-center rounded-md px-2 py-1 text-deep-green ${bgColor}`
  }
  classes = `${classes} ${bg} font-normal`
  return (
    <div className={classes}>
      {iconSrc && <InlineSvg width={17} height='auto' src={iconSrc} className={iconClass ?? ''} />}
      {children}
    </div>
  )
}

export default Tag
